module.exports = __webpack_public_path__ + "img/inu_gallery7.89d33768.jpg";